import api from '@/api/fetch'

import type { PrinterConfig, PrinterDriver } from '../types'

export default class AdyenPrinter implements PrinterDriver {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  async printImage(canvas: HTMLCanvasElement) {
    const splittedCanvas = document.createElement('canvas')
    const ctx = splittedCanvas.getContext('2d')!
    const parts = []
    const imgWidth = canvas.width
    const imgHeight = canvas.height
    splittedCanvas.width = imgWidth

    let currentHeight = 0
    const adderStep = 1000
    let currentAdder = adderStep

    while (currentHeight + currentAdder < imgHeight) {
      splittedCanvas.height = currentAdder
      ctx.drawImage(canvas, 0, currentHeight, imgWidth, currentAdder, 0, 0, imgWidth, currentAdder)
      const dataUrl = splittedCanvas.toDataURL('image/webp', 0.01)
      if (dataUrl.length > 90000) {
        parts.push(dataUrl)
        currentHeight += currentAdder
        currentAdder = adderStep
      } else {
        currentAdder += adderStep
      }
    }

    splittedCanvas.height = Math.min(currentAdder, imgHeight)
    ctx.drawImage(canvas, 0, currentHeight, imgWidth, currentAdder, 0, 0, imgWidth, currentAdder)
    parts.push(splittedCanvas.toDataURL('image/webp', 0.01))

    for (const part of parts) {
      const partData = part.split('base64,')[1]
      await api.post('pos/adyen/print', {
        imageBase64: partData,
        poiid: this.config.metadata.poiid
      })
    }
  }

  openCashDrawer() {
    // NO_OP
  }
}
